import React from 'react';

const BasicInformation = ({ productInfo }) => {
  if (!productInfo) return <div>No product information available.</div>;
  
  // Array of colors for tags
  const tagColors = [
    'bg-blue-100 text-blue-800',
    'bg-green-100 text-green-800',
    'bg-purple-100 text-purple-800',
    'bg-yellow-100 text-yellow-800',
    'bg-red-100 text-red-800',
    'bg-indigo-100 text-indigo-800',
    'bg-pink-100 text-pink-800',
    'bg-gray-100 text-gray-800',
    'bg-orange-100 text-orange-800',
    'bg-teal-100 text-teal-800'
  ];

  // Field configuration - easy to maintain and extend
  const fields = [
    { key: 'productName', label: 'Product Name' },
    { key: 'productOwner', label: 'Product Owner' },
    { key: 'parentDomainName', label: 'Parent Domain' },
    { key: 'subDomainName', label: 'Sub Domain' },
    { key: 'productCode', label: 'Product Code' },
    { key: 'dataLayer', label: 'Product Data Layer' },
    { key: 'domainName', label: 'Domain' },
    { 
      key: 'description', 
      label: 'Product Description',
      specialRender: (value) => (
        <span style={{whiteSpace: 'pre-wrap', wordBreak: 'break-word'}}>
          {value || 'N/A'}
        </span>
      )
    },
    { 
      key: 'productTag', 
      label: 'Product Tags',
      specialRender: (value) => {
        if (!value) return 'N/A';
        
        const tags = Array.isArray(value) ? value : [value];
        
        return (
          <div className="flex flex-wrap gap-2">
            {tags.map((tag, index) => (
              <span
                key={index}
                className={`px-2 py-1 rounded-full text-xs font-medium ${tagColors[index % tagColors.length]}`}
              >
                {tag}
              </span>
            ))}
          </div>
        );
      }
    }
  ];

  // Helper function to render a table row
  const renderField = (field) => {
    const value = productInfo[field.key];
    
    return (
      <tr key={field.key} className="hover:bg-gray-50 transition-colors">
        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
          {field.label}
        </td>
        <td className="px-6 py-4 text-sm text-gray-700">
          {field.specialRender ? field.specialRender(value) : (value || 'N/A')}
        </td>
      </tr>
    );
  };
  
  return (
    <div>
      <h3 className="text-xl font-bold text-gray-800 mb-4">Basic Information</h3>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-[#0000a0]">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Label</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Value</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {fields.map(renderField)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BasicInformation; 